import useCrud from 'hooks/useCrud';
import { accountList } from 'services/api/assistant.group';

function readList() {
  return accountList().then((res = []) => res);
}

export function useAvailableAccount() {
  return useCrud({
    readList,
  });
}

export default useAvailableAccount;
